import { Component, EventEmitter, Output } from '@angular/core';
import { DatosEnviosService } from '../../services/datos-envios.service';
import { FiltroEnvio } from 'src/app/shared/models/filtros';
import { Router } from '@angular/router';
import { DesplegableData } from 'src/app/shared/components/sqp-components/sqpDesplegable/models/desplegable-data';

@Component({
  selector: 'app-envios-filtros-nuevos',
  templateUrl: './envios-filtros-nuevos.component.html',
  styleUrls: ['./envios-filtros-nuevos.component.css']
})
export class EnviosFiltrosNuevosComponent {

  estados: DesplegableData[] = [];
  estadoSeleccionado: DesplegableData | undefined;
  @Output() filtrarEnvios: EventEmitter<FiltroEnvio> = new EventEmitter<FiltroEnvio>();

  constructor(private datosEnviosService: DatosEnviosService,
              private router: Router) {
                this.getListaEstados();
              }

  ngOnInit(): void {
    this.estadoSeleccionado = this.obtenerEstadoInicial();
    this.aplicarPreseleccionEstado();
  }

  getListaEstados() {
    this.estados = this.datosEnviosService.GetEstadosLista();
  }

  actualizaFiltroEstado(estadoSeleccionado: any){
    this.estadoSeleccionado = estadoSeleccionado;
    let tipo;
    if(this.estadoSeleccionado.desc === 'Todos los estados'){
      tipo = {id:'TODOS', desc:'TODOS'}
    } else {
      tipo = this.estadoSeleccionado;
    }

    const filtroEstado: FiltroEnvio = {
      text: 'Estado',
      textoBuscar: '',
      value: tipo?.desc??'',
      estado: tipo?.desc??'',
      idTipoEnvio: ""
    }

    this.filtrarEnvios.emit(filtroEstado);
  }

  private aplicarPreseleccionEstado(): void {
    const estadoSeleccionadoId = this.estadoSeleccionado?.id;
    this.estados = this.estados.map((estado) => ({
      ...estado,
      seleccionado: estado.id === estadoSeleccionadoId
    }));
  }

  private obtenerEstadoInicial(): DesplegableData | undefined {
    if (this.router.url.includes('incompletos')) {
      return this.obtenerEstadoPorDescripcion('Incompleto');
    }

    const filtroEstado = this.datosEnviosService.filtros.find((x) => x.text === 'Estado');
    if (!filtroEstado) {
      return this.estados[0];
    }

    const descripcionEstado = filtroEstado.estado === 'TODOS' ? 'Todos los estados' : filtroEstado.estado;
    return this.obtenerEstadoPorDescripcion(descripcionEstado);
  }

  private obtenerEstadoPorDescripcion(descripcion: string): DesplegableData | undefined {
    return this.estados.find((estado) => estado.desc === descripcion) || this.estados[0];
  }

}
